export default function PageHeader({ title, description, action, testId }) {
  return (
    <div className="mb-6 flex flex-col md:flex-row md:items-end md:justify-between gap-4" data-testid={testId}>
      <div className="space-y-1.5">
        <div className="flex items-center gap-2">
          <div className="h-1 w-8 bg-blue-600 rounded-full" />
          <span className="text-[10px] uppercase tracking-widest text-blue-600 font-semibold">
            Yönetim Paneli
          </span>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
          {title}
        </h1>
        {description && (
          <p className="text-sm text-slate-500 max-w-2xl">{description}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
